import icon from 'vue-svgicon';

icon.register({
    'regular/check-double-1': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M23.25 4.249L11.808 19.505a1.5 1.5 0 0 1-2.261.161L6.57 16.689M6 19.76a1.5 1.5 0 0 1-2.133.012L.89 16.8M17.43 4.355L9.29 15.209" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
